
import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import { WindowType } from '../../util';
import Toasted from 'vue-toasted';
import TabButton from '../util/TabButton';
import Tab1 from './Tabs/Tab1';
import Reports from './Tabs/Reports';
import TabNotifications from './Tabs/TabNotifications';
import TabLocalization from './Tabs/TabLocalization';
import Kiosk from "./Tabs/Kiosk.vue";

Vue.use(Toasted, { duration: 2000 });

declare var window: WindowType;

@Component({
  components: {
    Kiosk,
    Tab1,
    TabNotifications,
    TabButton,
    TabLocalization,
    Reports,
  },
})
export default class Settings extends Vue {
  tab: 'tab1' | 'reports' | 'tabNotifications' | 'kiosk' | 'tabLocalization' = 'tab1';

  get canGeneral(): boolean {
    return window.application.permissions.settings.general;
  }

  get canNotification(): boolean {
    return window.application.permissions.settings.notifications;
  }

  get canLocalization(): boolean {
    return window.application.permissions.settings.localization;
  }
}
